import { Pipe, PipeTransform } from '@angular/core';

@Pipe({standalone: true,  name: 'ellipsize' })
export class EllipsizePipe implements PipeTransform {
    constructor(
    ) { }

    public transform(str: string, maxLength: number, replacement = '...') {
        if (!maxLength) {
            return str;
        }

        if (str.length > maxLength) {
            return str.substr(0, maxLength) + replacement;
        }

        return str;
    }
}
